// extracted by mini-css-extract-plugin
export default {"avatar":"OverlappedAvatars_avatar__Dnpwz","remainder":"OverlappedAvatars_remainder__j3P-M"};